module.exports = __webpack_public_path__ + "static/img/embed_verify.547dc13d.png";